import React from 'react';
import './PetAnimations.css';

export default function PigmyKrakenSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#9B5DC4';
  const bodyLight = '#C497E0';
  const bodyDark = '#683D87';
  const suckers = '#F1C6E8';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Water bubbles */}
      <circle cx="20" cy="30" r="2" fill="#B8E0F4" opacity="0.5" />
      <circle cx="100" cy="36" r="1.5" fill="#B8E0F4" opacity="0.5" />
      <circle cx="14" cy="60" r="1.5" fill="#B8E0F4" opacity="0.4" />
      <circle cx="106" cy="70" r="2" fill="#B8E0F4" opacity="0.4" />

      {/* Tentacles (back layer) */}
      <path d="M40 78C28 86 22 96 26 106C32 102 36 94 42 88Z" fill={bodyDark} />
      <path d="M80 78C92 86 98 96 94 106C88 102 84 94 78 88Z" fill={bodyDark} />
      {/* Tentacles (mid) */}
      <path d="M44 82C36 92 32 102 38 108C44 102 46 94 50 90Z" fill={bodyColor} />
      <path d="M76 82C84 92 88 102 82 108C76 102 74 94 70 90Z" fill={bodyColor} />
      {/* Tentacles (front, curlier) */}
      <path d="M52 86C46 94 44 104 50 108C54 102 54 96 56 92Z" fill={bodyLight} />
      <path d="M68 86C74 94 76 104 70 108C66 102 66 96 64 92Z" fill={bodyLight} />
      {/* Front center tentacles */}
      <path d="M56 90C54 98 56 106 60 106C64 106 66 98 64 90Z" fill={bodyColor} />
      {/* Suckers on a couple front tentacles */}
      <circle cx="50" cy="96" r="1.2" fill={suckers} />
      <circle cx="48" cy="102" r="1" fill={suckers} />
      <circle cx="70" cy="96" r="1.2" fill={suckers} />
      <circle cx="72" cy="102" r="1" fill={suckers} />
      <circle cx="60" cy="100" r="1" fill={suckers} />

      {/* Head/mantle (big bulbous dome) */}
      <ellipse cx="60" cy="56" rx="32" ry="30" fill={bodyColor} />
      {/* Head highlight */}
      <ellipse cx="48" cy="42" rx="12" ry="10" fill={bodyLight} opacity="0.7" />
      <ellipse cx="76" cy="46" rx="6" ry="4" fill={bodyLight} opacity="0.5" />
      {/* Tiny mantle fins */}
      <path d="M30 42L22 36L30 50Z" fill={bodyDark} />
      <path d="M90 42L98 36L90 50Z" fill={bodyDark} />
      {/* Big eyes */}
      <circle cx="48" cy="58" r="9" fill="white" />
      <circle cx="72" cy="58" r="9" fill="white" />
      <circle cx="50" cy="60" r="5" fill="#2C2419" />
      <circle cx="74" cy="60" r="5" fill="#2C2419" />
      <circle cx="51.5" cy="58" r="1.8" fill="white" />
      <circle cx="75.5" cy="58" r="1.8" fill="white" />
      <circle cx="48" cy="62" r="0.8" fill="white" opacity="0.7" />
      <circle cx="72" cy="62" r="0.8" fill="white" opacity="0.7" />
      {/* Tiny smile */}
      <path d="M56 76C58 78 62 78 64 76" stroke={bodyDark} strokeWidth="1" strokeLinecap="round" fill="none" />
      {/* Cheek blush */}
      <circle cx="38" cy="68" r="3" fill="#F8A0C8" opacity="0.4" />
      <circle cx="82" cy="68" r="3" fill="#F8A0C8" opacity="0.4" />
    </svg>
  );
}
